module.exports = __webpack_public_path__ + "static/media/stand-out.2876de28.png";